import OrderNotifyConfig from "./OrderNotifyConfig";

export default OrderNotifyConfig;
